import React from 'react';
import { getPassportStatusLabelFromEnumKey } from '../constants/passportStatus';

export default class PassportColorTransformer {
    transform(value) {
        // Sulu select fields may pass the full option object {name, value} instead of a plain string
        const status = (value !== null && typeof value === 'object') ? value.value : value;

        let color;

        switch (status) {
            case 'ACTIVE':
                color = 'green';
                break;
            case 'REQUESTED':
            case 'CHANGED':
            case 'RESENT':
                color = 'gold';
                break;
            case 'RETURNED':
                color = 'orange';
                break;
            case 'APPROVED':
                color = 'blue';
                break;
            case 'REJECTED':
            case 'CHANGE_DECLINED':
                color = 'red';
                break;
            case 'DEACTIVATED':
            case 'PRE_REQUEST':
                color = 'gray';
                break;
            default:
                color = 'red';
        }

        return (
            <div style={{ color }}>
                {getPassportStatusLabelFromEnumKey(status)}
            </div>
        );
    }
}
